import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { ArrowLeftOutlined } from '@ant-design/icons'

import {
  getActivateOrderPageKey,
  getOrderPageKey,
  getOrderRequirementsStepKey,
} from 'sections/LKSection/modules/OrderModule/utils'
import { ContainerLK } from 'sections/LKSection/shared/components/ContainerLK/ContainerLK'
import { Margin, Padding } from 'components/ui'
import { Href } from 'components/ui/Href/Href'
import { ListItem } from 'components/ui/ListItem/ListItem'
import { Button, Flex, Text, Title } from 'components/uiKit'
import { getCreateMovingOrderRoute } from 'utils/helpers/routes/getRoutes'
import { docs } from 'shared/constants/docs'
import { LKRoutesEnum } from 'shared/constants/routes'
import { colors } from 'shared/constants/values'

import { PvzKeys } from '../../data'

const getKey = (key: string) => `${PvzKeys.movingPage}.${key}`

export const MovingPvzPage = observer(() => {
  const { pvzId } = useParams()
  const navigate = useNavigate()
  const { t } = useTranslation()

  const backButtonHandler = () => {
    navigate(LKRoutesEnum.pvz)
  }

  const createOrderHandler = () => {
    if (pvzId) {
      navigate(getCreateMovingOrderRoute(+pvzId))
    }
  }

  return (
    <ContainerLK>
      <Padding py={32} style={{ width: '100%' }}>
        <Margin mb={32}>
          <Flex gap={16} align="center">
            <Button shape="circle" icon={<ArrowLeftOutlined />} onClick={backButtonHandler} />

            <Title>{t(getKey('Переезд ПВЗ'))}</Title>
          </Flex>
        </Margin>

        <Flex vertical gap={16}>
          <Title level={5}>{t(getKey('Переезд в другое помещение'))}</Title>

          <Text>{t(getKey('Переезд возможен в радиусе 500'))}</Text>

          <Flex vertical>
            <Margin mb={8}>
              <Text strong>{t(getKey('Требования к помещению'))}:</Text>
            </Margin>

            <ListItem>
              <Text>{t(getKey('Расположение на первом'))}</Text>
            </ListItem>
            <ListItem>
              <Text>{t(getKey('Не проходное помещение'))}</Text>
            </ListItem>
            <ListItem>
              <Text>{t(getKey('Площадь от 30'))}</Text>
            </ListItem>
          </Flex>

          <Text>{t(getKey('Рекомендуем помещение'))}</Text>

          <Flex vertical gap={16}>
            <Flex vertical>
              <Margin mb={8}>
                <Text strong>{t(getKey('Как действовать после'))}</Text>
              </Margin>

              <ListItem>
                <Text>
                  {t(getKey('Выполните ремонт по'))}{' '}
                  <Href href={docs.brandbook} target={'_blank'} style={{ color: colors.corp }}>
                    {t(getOrderRequirementsStepKey('брендбуку'))}
                  </Href>{' '}
                  {t(getKey('Подготовьтесь к открытию'))}
                </Text>
              </ListItem>

              <ListItem>
                <Text>
                  {t(getKey('Минимальный набор для открытия'))}{' '}
                  <Href href={docs.brandbook} target={'_blank'} style={{ color: colors.corp }}>
                    {t(getKey('брендбуке'))}
                  </Href>
                  .
                </Text>
              </ListItem>
            </Flex>

            <Flex vertical>
              <Margin mb={8}>
                <Text strong>{t(getActivateOrderPageKey('Активация ПВЗ'))}</Text>
              </Margin>

              <ListItem>
                <Text>{t(getKey('По завершении ремонтных'))}</Text>
              </ListItem>

              <ListItem>
                <Text>{t(getKey('Старый ПВЗ будет деактивирован'))}</Text>
              </ListItem>

              <ListItem>
                <Text>{t(getKey('В течение одного дня'))}</Text>
              </ListItem>
            </Flex>

            <Flex vertical>
              <Margin mb={8}>
                <Text strong>{t(getKey('Фирменная вывеска'))}</Text>
              </Margin>

              <ListItem>
                <Text>{t(getKey('Если сейчас в вашем ПВЗ'))}</Text>
              </ListItem>

              <ListItem>
                <Text>{t(getKey('Если вывеска старого формата'))}</Text>
              </ListItem>
            </Flex>

            <Flex vertical>
              <Margin mb={8}>
                <Text strong>{t(getKey('ПВЗ с упрощёнными условиями'))}</Text>
              </Margin>

              <Text>{t(getKey('Процесс переезда упрощённого'))}</Text>
            </Flex>
          </Flex>

          <Margin mt={16}>
            <Flex>
              <Button onClick={createOrderHandler}>{t(getOrderPageKey('Создать заявку'))}</Button>
            </Flex>
          </Margin>
        </Flex>
      </Padding>
    </ContainerLK>
  )
})
